import { SearchInput } from "components/ui/search-input";
import * as React from "react";

export const clientSearchTextMaxLength = 200;

interface Props {
    className: string;
    value: string;
    placeholder: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ClientSearchTextInput: React.FC<Props> = props => (
    <SearchInput {...props} type="text" maxLength={clientSearchTextMaxLength} />
);
